import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CalendarCheck, Phone, EnvelopeSimple, ArrowUpRight } from "@phosphor-icons/react";
import { STUDIO_INFO } from "@/data/content";

export default function BookCallDialog({ triggerClassName = "" }) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid="book-call-trigger"
          className={`inline-flex items-center gap-3 bg-white hover:bg-zinc-200 text-black px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] transition-colors ${triggerClassName}`}
        >
          <CalendarCheck size={16} weight="bold" />
          Book a Call
        </button>
      </DialogTrigger>
      <DialogContent
        data-testid="book-call-dialog"
        className="bg-[#0a0a0a] border border-white/15 rounded-none text-[#F5F5F0] max-w-lg p-0"
      >
        <div className="p-7 md:p-9">
          <DialogHeader className="text-left">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#E50914] mb-4">
              // Schedule an Intro Call
            </p>
            <DialogTitle className="font-display uppercase text-white text-3xl md:text-4xl leading-[0.95] mb-3">
              Let's talk <br /> about the record.
            </DialogTitle>
            <DialogDescription className="text-zinc-400 text-sm md:text-base leading-relaxed">
              Pick the fastest way to reach the studio. We reply within a few
              hours during working days.
            </DialogDescription>
          </DialogHeader>

          <div className="mt-8 space-y-3">
            <a
              href={`tel:${STUDIO_INFO.phoneTel}`}
              data-testid="book-call-phone"
              className="group flex items-center justify-between gap-4 border border-white/15 hover:border-[#E50914] hover:bg-[#0f0f0f] px-5 py-4 transition-colors"
            >
              <div className="flex items-center gap-4">
                <span className="w-10 h-10 bg-[#E50914] flex items-center justify-center">
                  <Phone size={18} weight="bold" className="text-white" />
                </span>
                <div className="text-left">
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                    Call Now
                  </div>
                  <div className="text-white text-base font-medium">
                    {STUDIO_INFO.phoneDisplay}
                  </div>
                </div>
              </div>
              <ArrowUpRight size={18} weight="bold" className="text-zinc-500 group-hover:text-white" />
            </a>

            <a
              href={`mailto:${STUDIO_INFO.emailPrimary}?subject=Studio%20Inquiry%20%E2%80%94%20Intro%20Call&body=Hi%20Mir%2C%0A%0AI%27d%20like%20to%20book%20a%20call%20to%20discuss%3A%0A%0A-%20Project%3A%20%0A-%20Timeline%3A%20%0A-%20Budget%3A%20%0A%0AThanks%2C%0A`}
              data-testid="book-call-email"
              className="group flex items-center justify-between gap-4 border border-white/15 hover:border-[#E50914] hover:bg-[#0f0f0f] px-5 py-4 transition-colors"
            >
              <div className="flex items-center gap-4">
                <span className="w-10 h-10 bg-[#0f0f0f] border border-white/20 flex items-center justify-center">
                  <EnvelopeSimple size={18} weight="bold" className="text-white" />
                </span>
                <div className="text-left">
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                    Email the Studio
                  </div>
                  <div className="text-white text-base font-medium break-all">
                    {STUDIO_INFO.emailPrimary}
                  </div>
                </div>
              </div>
              <ArrowUpRight size={18} weight="bold" className="text-zinc-500 group-hover:text-white" />
            </a>

            <button
              data-testid="book-call-form"
              onClick={() => {
                setOpen(false);
                setTimeout(() => {
                  const el = document.getElementById("contact");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }, 180);
              }}
              className="group w-full flex items-center justify-between gap-4 border border-white/15 hover:border-[#E50914] hover:bg-[#0f0f0f] px-5 py-4 transition-colors"
            >
              <div className="flex items-center gap-4">
                <span className="w-10 h-10 bg-[#0f0f0f] border border-white/20 flex items-center justify-center">
                  <CalendarCheck size={18} weight="bold" className="text-white" />
                </span>
                <div className="text-left">
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                    Send a Brief
                  </div>
                  <div className="text-white text-base font-medium">
                    Fill the inquiry form
                  </div>
                </div>
              </div>
              <ArrowUpRight size={18} weight="bold" className="text-zinc-500 group-hover:text-white" />
            </button>
          </div>

          <div className="mt-6 pt-5 border-t border-white/10 font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">
            Philadelphia · Open to travel worldwide
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
